import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { AdjustmentEntity } from '../../domain/entities/AdjustmentEntity'
export class AdjustmentModel extends AdjustmentEntity {
  constructor(dataDto: {
    id?: number
    amount?: number
    type?: AdjustmentEntity['type']
    adjustmentReasonId?: number | null
    reason?: string | null
    note?: string | null
    effectiveDate?: string
    driver?: AdjustmentEntity['driver']
  }) {
    super()
    mapEntityProperties<AdjustmentModel>(this, dataDto, {
      map: {
        adjustmentReasonId: dataDto.adjustmentReasonId,
        adjustmentReasonName: dataDto.reason,
        adjustmentReason: dataDto.adjustmentReasonId
          ? {
              id: dataDto.adjustmentReasonId,
              name: dataDto.reason
            }
          : undefined
      }
    })
  }
}
